import { ProductState } from "@/core/products/components/ProductsTable";
import * as z from "zod";

export const productAdjustmentSchema = z.object({
  productAdjustmentTypeId: z
    .string()
    .min(1, { message: "El tipo de ajuste debe ser valido" }),
  storageId: z.string().min(1, { message: "El almacen debe ser valido" }),
  zoneId: z.string().min(1, { message: "La zona debe ser valida" }),
  description: z.string().min(1, { message: "La descripción debe ser valida" }),
  products: z.custom<ProductState[]>(),
});

export type ProductAdjustmentFormInput = z.infer<
  typeof productAdjustmentSchema
>;
